/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_S1Inputs */

const en_tut_jadwal_s1 = /** @type {(inputs: Tut_Jadwal_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The **Jadwal internal berikutnya** card on the Meeting page lists up to five meetings in the next seven days that you may access, with a countdown.`)
};

const id_tut_jadwal_s1 = /** @type {(inputs: Tut_Jadwal_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu **Jadwal internal berikutnya** di halaman Meeting menampilkan sampai lima rapat dalam tujuh hari ke depan yang boleh Anda akses, lengkap dengan hitung mundur.`)
};

/**
* | output |
* | --- |
* | "The **Jadwal internal berikutnya** card on the Meeting page lists up to five meetings in the next seven days that you may access, with a countdown." |
*
* @param {Tut_Jadwal_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_s1 = /** @type {((inputs?: Tut_Jadwal_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_s1(inputs)
	return en_tut_jadwal_s1(inputs)
});